/*-- import aliases -----------
'!/...' -> project root
'~/...' -> js folder root
-----------------------------*/
import { setup } from "~/core";
setup();

import "~/global/_svgIcons";
import "~/global/_cookies";

import "~/components/_accordionCR";
import "~/components/_alert";
import "~/components/_alertCookie";
import "~/components/_filters";
import "~/components/_rfp";
import "~/components/_calculator";
import "~/components/_tabs";
import "~/components/_forms";
import "~/components/_statsBar";
import "~/components/_leadership";
import "~/components/_interiorNav";
import "~/components/_videoModal";
import "~/components/_survey";
import "~/components/_tags";
import "~/components/_photoVideoGrid";
import "~/components/_tableRes";
import "~/components/_communityReport"
import "~/components/_dialog";
import "~/components/_tooltip";